import apiHeader from '@/helpers/apiHeader';

const mailConfigurationService = {
  list(page, params) {
    return apiHeader.get('mail-configuration?page=' + page, { params });
  },
  get(code) {
    return apiHeader.get('general-setting/app-configuration/' + code);
  },
  create(params) {
    return apiHeader.post('mail-configuration/create', params);
  },
  testConnection() {
    return apiHeader.get('general-setting/app-configuration/mail-configuration/test-connection');
  },
  update(mailConfig) {
    const { code, ...payload } = mailConfig;
    return apiHeader.patch('general-setting/app-configuration/' + code, payload);
  },
  updateMaxSize(maxSizeConfig) {
    const { code, ...payload } = maxSizeConfig;
    return apiHeader.patch('general-setting/app-configuration/' + code, payload);
  },
};

export default mailConfigurationService;
